import { Box, SideSheetBody, SideSheetContentCol } from '@bechtel/gds';
import { t, Trans } from '@lingui/macro';
import { useState } from 'react';
import { ErrorBoundary } from '~/components/atoms/error-boundary';
import { UnderConstruction } from '~/components/atoms/under-construction';
import { DisplaySettings } from './display-settings';
import {
  DrawerBackdropStyled,
  DrawerCloseStyled,
  DrawerHeaderStyled,
  DrawerOuterStyled,
  TabButtonStyled,
  TabListStyled,
} from './styled';
import { SettingsTab } from './types';

export const Settings = ({ close, updateUserPreferenceSettings }) => {
  const [selectedTab, setSelectedTab] = useState<SettingsTab>(SettingsTab.DISPLAY_SETTINGS);

  return (
    <DrawerBackdropStyled>
      <DrawerOuterStyled>
        <DrawerHeaderStyled title={t`My Settings`}>
          <DrawerCloseStyled onClick={close}></DrawerCloseStyled>
        </DrawerHeaderStyled>
        <SideSheetBody>
          <ErrorBoundary>
            <SideSheetContentCol>
              <TabListStyled>
                <TabButtonStyled
                  isSelected={selectedTab === SettingsTab.TUTORIALS}
                  key={SettingsTab.TUTORIALS}
                  onClick={() => setSelectedTab(SettingsTab.TUTORIALS)}
                >
                  <Trans>Tutorials</Trans>
                </TabButtonStyled>
                <TabButtonStyled
                  key={SettingsTab.DISPLAY_SETTINGS}
                  isSelected={selectedTab === SettingsTab.DISPLAY_SETTINGS}
                  onClick={() => setSelectedTab(SettingsTab.DISPLAY_SETTINGS)}
                >
                  <Trans>Display Settings</Trans>
                </TabButtonStyled>
                <TabButtonStyled
                  key={SettingsTab.NOTIFICATIONS}
                  isSelected={selectedTab === SettingsTab.NOTIFICATIONS}
                  onClick={() => setSelectedTab(SettingsTab.NOTIFICATIONS)}
                >
                  <Trans>Notifications</Trans>
                </TabButtonStyled>
                <TabButtonStyled
                  key={SettingsTab.CONTACT}
                  isSelected={selectedTab === SettingsTab.CONTACT}
                  onClick={() => setSelectedTab(SettingsTab.CONTACT)}
                >
                  <Trans>Contact</Trans>
                </TabButtonStyled>
              </TabListStyled>
              {selectedTab === SettingsTab.DISPLAY_SETTINGS && (
                <ErrorBoundary>
                  <DisplaySettings
                    close={close}
                    updateUserPreferenceSettings={(language) => {
                      updateUserPreferenceSettings(language);
                    }}
                  />
                </ErrorBoundary>
              )}
              {selectedTab !== SettingsTab.DISPLAY_SETTINGS && (
                <Box mx={{ sm: '800' }} my={{ sm: '900' }}>
                  <UnderConstruction />
                </Box>
              )}
            </SideSheetContentCol>
          </ErrorBoundary>
        </SideSheetBody>
      </DrawerOuterStyled>
    </DrawerBackdropStyled>
  );
};
